export default __webpack_public_path__ + "static/media/closet5-after2-480w.2101e555.png";